import React from 'react';

import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import SearchableMenu, {SearchableMenuProps} from 'ui-library/menus/SearchableMenu';
import {TIMEZONE_OPTIONS, UTC_TIMEZONE} from 'util/DateConstants';

export interface TimezonePickerDropdownProps {
  disabled: boolean;
  value?: string | null;
  onChange: (timezone: string) => void;
  menuProps?: Partial<Pick<SearchableMenuProps, 'height' | 'width'>>;
}

export default function TimezonePickerDropdown(props: TimezonePickerDropdownProps): JSX.Element {
  const selectedTimezone = props.value || UTC_TIMEZONE;
  return (
    <SelectDropdown
      disabled={props.disabled}
      menu={
        <SearchableMenu
          selectedValue={selectedTimezone}
          optionDatas={TIMEZONE_OPTIONS.map((option) => ({name: option, value: option}))}
          onSelect={props.onChange}
          height={props.menuProps?.height}
          width={props.menuProps?.width}
          scrollable={true}
        />
      }
      displayName={selectedTimezone}
    />
  );
}
